// =====================================================================
// Telegram WebApp store — wraps the SDK ready state, initData, viewport
// and current theme. Hydrated once by `TgProvider` (which already
// handles the bootstrap and the theme listener). The provider imports
// from here so the rest of the app reads from a single source.
// =====================================================================

import { create } from "zustand";
import type { TelegramWebApp } from "@/shared/telegram/types";

export type TelegramColorScheme = "light" | "dark";

interface TelegramState {
  ready: boolean;
  webApp: TelegramWebApp | null;
  initData: string;
  colorScheme: TelegramColorScheme;
  setReady: (ready: boolean) => void;
  setWebApp: (webApp: TelegramWebApp | null) => void;
  setInitData: (initData: string) => void;
  setColorScheme: (scheme: TelegramColorScheme) => void;
}

export const useTelegramStore = create<TelegramState>()((set) => ({
  ready: false,
  webApp: null,
  initData: "",
  colorScheme: "light",
  setReady: (ready) => set({ ready }),
  setWebApp: (webApp) => set({ webApp }),
  setInitData: (initData) => set({ initData }),
  setColorScheme: (colorScheme) => set({ colorScheme }),
}));

export const useTgReady = () => useTelegramStore((s) => s.ready);
export const useTgWebApp = () => useTelegramStore((s) => s.webApp);
export const useTgInitData = () => useTelegramStore((s) => s.initData);
export const useTgColorScheme = () => useTelegramStore((s) => s.colorScheme);
